import { useContext, useEffect, useState } from "react";

import { ITableRowData } from "../../../../shared/components/normal-table/normal-table";
import SimpleModal from "../../../../shared/components/simple-modal/simple-modal";
import AuthContext from "../../../../shared/context/auth-context";
import { IEnumerationOption } from "../../../../shared/definitions/datatypes";
import { useHttpNonTable } from "../../../../shared/hooks/use-httpNonTable";
import { getAllDataNonTable } from "../../../../shared/utils/api";
import { processTypeStageActionTypesOptions } from "../../../../shared/utils/static-values";
import { createUUID } from "../../../../shared/utils/utils";
import SearchInput from "../../../components/search-input/search-input";

export interface IPopupConfig {
  show: boolean;
  action: ITableRowData | undefined;
  handlePopupClosed(result: ITableRowData | undefined): void;
}

const ActionPopup = ({
  show,
  action,
  handlePopupClosed,
}: IPopupConfig) => {
  const authCtx = useContext(AuthContext);
  const [actions, setActions] = useState<ITableRowData[]>([]);
  const [actionData, setActionData] = useState<ITableRowData>(action || {id: ""});
 
  const {
    sendRequest: getActions,
    status: getActionsStatus,
    data: getActionsData,
    error: getActionsError
  } = useHttpNonTable(getAllDataNonTable, false, authCtx.token, undefined, "manager");

  useEffect(() => {
    getActions("actions?order_by=name asc");
  }, []);

  useEffect(() => {
    setActionData(action || {id: ""});
  }, [action]);

  useEffect(() => {
    if (getActionsData && getActionsStatus === "completed" && !getActionsError) {
      setActions(getActionsData);
    }
  }, [getActionsData, getActionsStatus, getActionsError]);

  const handleOnSelectionChange = (selectedOption: IEnumerationOption | undefined) => {
    const matchedAction = actions.find(action => action.id === selectedOption?.id);
    if (!matchedAction) {
      return;
    }
    const newActionData = {
      ...actionData,
      selected_action_id: selectedOption?.id,
      name: matchedAction.name,
      to_perform: matchedAction.to_perform,
    };
    setActionData(newActionData);
  };  
  
  const handleOnTypeSelectionChange = (selectedOption: IEnumerationOption | undefined) => {
    setActionData({...actionData, action_type: selectedOption?.id});
  };

  const handleSubmit = () => {
    const newActionData = {
      ...actionData
    };

    if (!newActionData.id) {
      newActionData.id = createUUID();
    }
    handlePopupClosed(newActionData);
    setActionData({id: ""});
  };

  const modalContent = () => {
    return <div>
      <SearchInput
        label="Action"
        inputKey="action"
        required={true}
        data={actions.map((action: ITableRowData) => ({ id: action.id, name: action.name }))}
        handleOnChange={handleOnSelectionChange}
        selectedOption={actionData.selected_action_id}
        onFocusEmpty={true}
      />      
      <SearchInput
        label="Action type"
        inputKey="action_type"
        required={true}
        onFocusEmpty={true}
        data={processTypeStageActionTypesOptions}
        handleOnChange={handleOnTypeSelectionChange}
        selectedOption={actionData.action_type}
      />
    </div>;
  };

  return (
    <SimpleModal
      modalBody={modalContent()}
      mode={"Action"}
      handleModalClosed={() => handlePopupClosed(undefined)}
      handleSubmit={handleSubmit}
      show={show}
      buttonText={actionData?.id ? "Save" : "Add"}
      allowScrollOnBody={false}
    />
  );
};

export default ActionPopup;
